module.exports = __webpack_public_path__ + "static/img/zfb_pay3.0c5ceb4a.jpg";